export enum GradeColor {
    ERROR = "#FD3559",
    WARNING = "#FF8400",
    SUCCESS = "#4FBD19",
}

export enum GradeFilledColor {
    ERROR = "#FD3559",
    WARNING = "#FF8400",
    SUCCESS = "#2FB801",
}

const INTERVAL = [
    {
        min: 90,
        grade: "A",
        tag: "success",
        color: GradeColor.SUCCESS,
        filledColor: GradeFilledColor.SUCCESS,
    },
    {
        min: 80,
        grade: "B",
        tag: "success",
        color: GradeColor.SUCCESS,
        filledColor: GradeFilledColor.SUCCESS,
    },
    {
        min: 70,
        grade: "C",
        tag: "warning",
        color: GradeColor.WARNING,
        filledColor: GradeFilledColor.WARNING,
    },
    {
        min: 60,
        grade: "D",
        tag: "warning",
        color: GradeColor.WARNING,
        filledColor: GradeFilledColor.WARNING,
    },
    {
        min: 0,
        grade: "F",
        tag: "error",
        color: GradeColor.ERROR,
        filledColor: GradeFilledColor.ERROR,
    },
];

export const getScoreGrade = (score: number, demoninator: number = 100) => {
    const scoreNormalized = score * (100 / demoninator);

    for (const item of INTERVAL) {
        if (scoreNormalized >= item.min) return item;
    }

    return INTERVAL[INTERVAL.length - 1];
};
